import React from 'react';
import { Box, ButtonGroup } from '@pinwheel/origami';
import Action from './TemplateFormAction';
function Actions(props) {
    var actions = (props.actions || []).map(function (action) { return (React.createElement(Action, { key: action.label, action: action, onSubmit: props.onSubmit })); });
    return (React.createElement(Box, { sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        } },
        React.createElement(ButtonGroup, { orientation: "horizontal" }, actions)));
}
export default Actions;
